import { Directive, HostListener, Inject } from '@angular/core';
import { FlooriStepperComponent } from '@floori-web-components';

@Directive({
    selector: '[flooriStepperNext]',
    standalone: true,
})
export class FlooriStepperNextDirective {
    constructor(@Inject(FlooriStepperComponent) private stepper: FlooriStepperComponent) {}

    @HostListener('click') onClick() {
        this.stepper.next();
    }
}
